<template>
    <div class="appBoxContainer">
        <div id="app" :key="langKey" :class="!isHalfClass?'appContainer':'appContainer1440px'">
            <topMenu v-if="headerFlag" :flag="floatFlag" :loginFlag="loginFlag" :langKey="langKey"
                     :key="`${$route.fullPath}top${Date.now()}`"></topMenu>
            <router-view :key="`${$route.fullPath}view${Date.now()}`"/> <!--加上key表示不会使用缓存，每个view都是独立的-->
            <bottomNav v-if="headerFlag"/>
            <bottomBox v-if="headerFlag" :loginFlag="loginFlag"
                       :key="`${$route.fullPath}bottom${Date.now()}`"></bottomBox>
        </div>
    </div>
</template>
<script>
import menuDateFR from "./assets/source/categories.menu.top.fr";
import menuDateEN from "./assets/source/categories.menu.top.en.json";
import menuDateES from "./assets/source/categories.menu.top.es.json";
import menuDateIT from "./assets/source/categories.menu.top.it.json";
import topMenu from "./components/topMenu"
import bottomBox from "./components/bottomBox"
import bottomNav from "@/components/bottomNav";

let commonUtils = require('@/utils/common_utils');
import common from './common'


export default {
    name: "app",
    metaInfo: {
        meta: [
            {
                name: 'p:domain_verify',
                content: '403b3fd63e818ee96e8b38d14d01cb0e',
            },
            {
                name: 'google-site-verification',
                content: 'ZZ9p-dD-7vEJjSawbNXHPpWXUhRbgfXR2N1LEXeHovg',
            },
            {
                name: '@context',
                content: 'http://schema.org',
            },
            {
                name: '@type',
                content: 'Organization',
            },
            {
                name: 'name',
                content: 'eFashion Paris',
            },
            {
                name: 'url',
                content: 'https://www.efashion-paris.com',
            },
            {
                name: 'logo',
                content: `${common.imgHost}front/img/v3/logos/logo-noir-fr.gif`,
            },
            {
                name: 'sameAs',
                content: ["https://www.facebook.com/efashionparis/",
                    "https://twitter.com/efashionparis",
                    "https://www.instagram.com/efashionparis_official/?hl=fr"],
            },
        ]
    },
    components: {
        topMenu,
        bottomBox,
        bottomNav,
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            headerFlag: true,
            floatFlag: true,
            langKey: 1,
            isHalfClass: false,
            menuDate: {},
        }
    },
    computed: {
        loginFlag() {
            return localStorage.getItem('token') ? true : false
            // return false
        },
    },
    watch: {
        '$route'(to, from) {
            console.log('to', to)
            // console.log('to',to)
            // console.log('from',from)
            window.scrollTo(0, 0);
            if (['/login','/login/', '/sign', '/sign/choose',
                    '/sign/signpage/buyer',
                    '/sign/signpage/seller',
                    '/Checkout',
                    '/checkout/',
                    '/result',
                    '/resetPassword'].includes(to.path)
                || to.path.includes('/checkout/')
                || to.path.includes('/admin/')
            ) {
                this.headerFlag = false
                console.log(this.headerFlag)
            } else {
                this.headerFlag = true
                console.log(this.headerFlag)
            }
            this.floatFlag = to.path == '/about'
            this.setAppClass();
        },
    },
    created() {
        // 判断是否是第一次加载这个页面，第一次加载vuex的数据会导致页面显示异常，需要重新刷新一次，
        let isFirstLoadPage = this.$store.state.isFirstLoadPage;
        this.get_client_page_img_list();
        this.get_config_system();
        Array.prototype.remove = function (val) {
            var index = this.indexOf(val);
            if (index > -1) {
                this.splice(index, 1);
            }
        };//Array.remove
        let lang = localStorage.getItem('lang') || 'fr'
        let langJson = require(`./assets/source/langV4/langv4.${lang.toLocaleLowerCase()}.json`)
        // console.log(langJson)
        localStorage.setItem('lang', lang)
        this.$store.commit('set', {key: 'langPage', value: langJson})

        // this.$api.menu.getLang({id_langue:lang}).then(data=>{
        //   localStorage.setItem('lang',lang)
        //   this.$store.commit('set',{key:'langPage',value:langJson})
        // })

        if (lang == 'fr') this.menuDate = menuDateFR;
        if (lang == 'en') this.menuDate = menuDateEN;
        if (lang == 'es') this.menuDate = menuDateES;
        if (lang == 'it') this.menuDate = menuDateIT;
        this.$store.commit('set', {key: 'categories', value: this.menuDate})
        this.$store.commit('set', {key: 'categoriesIds', value: this.getCategoriesIds(this.menuDate)});
        // this.$api.menu.getmenu().then(res=>{
        //   console.log(res)
        //   this.$store.commit('set',{key:'categories',value:res})
        // })

        this.setAppClass();
        this.isHome = this.$route.path == '/';
        // console.log('isFirstLoadPage2', isFirstLoadPage, this._isMobile(),this.isHome);
        //是移动端首页且第一次加载，就执行一次刷新
        if (isFirstLoadPage && this.isHome) {
            console.log('isFirstLoadPage3');
            this.$store.commit('set', {key: 'isFirstLoadPage', value: false});
            window.location.reload();
        }
    },
    methods: {
        //获取分类数组
        getCategoriesIds(menuDate) {
            let keys1Temp = Object.keys(menuDate);
            let keys1 = [];
            keys1Temp.forEach(key => {
                //key 11; 要转成{11:{1101:[],1102:[]},12:[]}
                let keys2Temp = Object.keys(menuDate[key].subcategories);
                if (commonUtils.isEmpty(keys2Temp)) return;
                let keys2 = [];
                keys2Temp.forEach(key2 => {
                    keys2[key2] = Object.keys(menuDate[key].subcategories[key2].subcategories);
                })
                keys1[key] = keys2;
            });
            console.log('support_categories_ids22', keys1);
            return keys1;
        },
        // 设置不同的appContainer的class
        setAppClass() {
            // this.isHalfClass = ['/','/homepage','/about' ].includes(this.$route.path) && !this.isMobile;
            this.isHalfClass = !this.isMobile;
        },
        //获取客户端所需要的动态图片
        get_client_page_img_list() {
            let params = {
                type: this.$store.state.isMobile ? 'mobile' : 'web',
            };
            this.$api.home.get_client_page_img_list(params).then(res => {
                if (res.code == 0) {
                    this.$store.commit('set', {key: 'client_page_imgs', value: res.data});
                }
            })
        },
        //获取客户端所需要的动态图片
        get_config_system() {
            this.$api.admin.get_config_system().then(res => {
                if (res.code == 0) {
                    let temp = {};
                    for (let item of res.data) {
                        temp[item.name] = item.value;
                    }
                    this.$store.commit('set', {key: 'config_system', value: temp});
                }
            })
        },
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            this.$store.commit('set', {key: 'isMobile', value: flag});
            return flag;
        },
    }
}
</script>
<style lang="less">
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css";
@import "https://sb-pgjs.paygreen.fr/latest/paygreen.min.css";

#app {
}

.appContainer {
    background-color: #F6F3F1;
    width: 100%;
    min-height: 100%;
}

.appContainer1440px {
    background-color: #F6F3F1;

    @media only screen and (min-width: 1440px){
        width: 1440px;
    }

    min-height: 100%;
    margin: auto;
}

.appBoxContainer {
    background-color: #F6F3F1;
}

.popper-panier {
    .el-popover__title {
        font-family: MaisonNeue-Bold;
        font-size: 0.1px;
        line-height: 12px;
        font-weight: bold;
    }
}


</style>
